"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any

exports.checkValidFiles = function (files) {
  if (!files) return true;
  var fileSize = +files / 1024 / 1024;
  if (fileSize > 1000) return false;
  return true;
};